import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshantempo() {



  const cardData =
  {
    keyword: 'Pune to Konkan Darshan Tempo Traveller Hire ',
    heading: 'Sanavi Travels: Pune to Konkan Darshan Tempo Traveller Hire',
    headingDescription: 'Sanavi Travels offers reliable Pune to Konkan Darshan Tempo Traveller Hire, providing safe, comfortable, and hassle-free group travel for families, pilgrims, friends, and tour groups planning a memorable Konkan Darshan tour. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for multi-day coastal tours, temple visits, and sightseeing across the Konkan region, ensuring spacious seating, air-conditioned comfort, and ample luggage space. With experienced chauffeurs well-versed in Konkan routes, flexible multi-day hire packages, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth and enjoyable journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to popular Konkan destinations such as Ganpatipule, Ratnagiri, Tarkarli, Devgad, Sindhudurg, and nearby temples and beaches, Sanavi Travels provides trusted Pune to Konkan Darshan Tempo Traveller hire services for travelers seeking comfort, safety, and a reliable coastal tour experience.',

    top: 'Top Places to Visit in Konkan with Sanavi Travels',


  "topPlaces": [
  {
    "title": "Ganpatipule",
    "description": "Ganpatipule is a serene coastal town in the Konkan region, famous for its pristine beach and the 400-year-old Swayambhu Ganpati Temple. The white sandy beach, clear waters, and lush green surroundings create a peaceful environment. The temple attracts devotees from across Maharashtra, blending spirituality with natural beauty. Ganpatipule is a perfect destination for those seeking tranquility, devotion, and scenic coastal charm."
  },
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri is a historic port city known for its scenic coastline, Alphonso mangoes, and cultural heritage. Attractions include Ratnadurg Fort, Thibaw Palace, and beautiful beaches like Ganeshghule and Bhatye. The city is also the birthplace of freedom fighter Lokmanya Tilak. Ratnagiri offers a rich mix of history, nature, and traditional Konkani culture."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is renowned for its crystal-clear waters and white sand, making it one of the best beaches in Konkan. It is a popular destination for snorkeling, scuba diving, and water sports. Located near the Karli River, the beach offers stunning sunsets and a calm atmosphere. Tarkarli is ideal for adventure lovers and travelers seeking untouched coastal beauty."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort is a majestic sea fort built by Chhatrapati Shivaji Maharaj in the 17th century. Located on an islet near Malvan, the fort showcases brilliant maritime engineering. It houses temples dedicated to Bhavani Mata, Shivaji Maharaj, and Hanuman. Sindhudurg Fort stands as a proud symbol of Maratha naval strength and Konkan’s historical legacy."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a popular beach destination close to Mumbai, known for its clean beaches and relaxed vibe. Attractions include Alibaug Beach, Nagaon Beach, and the historic Kolaba Fort, which is accessible during low tide. The town offers water sports, coastal cuisine, and scenic views. Alibaug is a favorite weekend getaway blending leisure, history, and nature."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli is a peaceful hill station by the sea, often referred to as the ‘Mini Mahabaleshwar of Konkan’. It is known for its cool climate, unspoiled beaches like Murud and Karde, and lush greenery. Dapoli also has historical temples and educational institutions. It is perfect for travelers seeking calm surroundings and natural beauty."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort is an unconquered sea fort located off the coast of Murud. Built by the Siddis, the fort stands strong amidst the Arabian Sea with massive walls and bastions. Accessible only by boat, it is an architectural marvel and historical wonder. Murud-Janjira reflects Konkan’s rich maritime and military heritage."
  },
  {
    "title": "Malvan",
    "description": "Malvan is a coastal town famous for its beaches, Sindhudurg Fort, and authentic Malvani cuisine. Coconut trees, coral beaches, and traditional fishing villages define its charm. The town is also known for snorkeling and scuba diving. Malvan offers a true taste of Konkan’s culture, food, and seaside life."
  },
  {
    "title": "Guhagar Beach",
    "description": "Guhagar Beach is a clean and less crowded beach surrounded by lush greenery and coconut groves. Its long stretch of soft sand and calm waves make it ideal for peaceful walks and relaxation. The nearby Vyadeshwar Temple adds spiritual significance to the area. Guhagar is a hidden gem for travelers seeking solitude and natural beauty."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar is a sacred coastal town known as the ‘Dakshin Kashi’ of Maharashtra. It is famous for the Harihareshwar Temple dedicated to Lord Shiva and its scenic beach. The temple complex is surrounded by hills and sea, offering a unique spiritual setting. Harihareshwar blends devotion, serenity, and scenic coastal landscapes."
  }
]
,




 "services": [
    {
      "name": "Pune to Konkan Darshan Tempo Traveller Hire",
      "description": "Pune to Konkan Darshan Tempo Traveller Hire provides comfortable and reliable vehicles for groups traveling from Pune to various Konkan destinations. Well-maintained and spacious, these vehicles are perfect for family trips, corporate outings, and group tours. Professional drivers ensure safety and punctuality, while passengers enjoy a smooth journey along scenic coastal routes. Flexible booking options and transparent pricing make it convenient for travelers planning their Konkan darshan itinerary."
    },
    {
      "name": "Konkan Darshan Tempo Traveller from Pune",
      "description": "Konkan Darshan Tempo Traveller from Pune offers flexible rental services for sightseeing and group trips to the Konkan region. Vehicles come with ample seating, luggage-friendly interiors, and air-conditioning for comfort. Experienced drivers handle long-distance routes efficiently, ensuring timely arrivals at tourist spots. Ideal for family vacations, corporate retreats, or friends’ group travel, this service provides convenience, reliability, and a pleasant travel experience."
    },
    {
      "name": "AC Tempo Traveller Konkan Tour",
      "description": "AC Tempo Traveller Konkan Tour offers air-conditioned vehicles for a comfortable and relaxed journey along the Konkan coast. Suitable for long-distance travel, family trips, or corporate outings, these vehicles provide spacious seating and luggage-friendly interiors. Skilled chauffeurs ensure safe driving and optimized routes, allowing passengers to enjoy the scenic beauty of Konkan without any travel stress."
    },
    {
      "name": "Luxury Tempo Traveller Konkan Darshan",
      "description": "Luxury Tempo Traveller Konkan Darshan provides premium vehicles for an elegant and comfortable travel experience. Equipped with reclining seats, entertainment systems, and ample luggage space, these vehicles are ideal for VIP trips, corporate tours, or special family outings. Professional drivers ensure timely pickups and safe transfers, making the journey to Konkan convenient, stylish, and enjoyable."
    },
    {
      "name": "Family Tempo Traveller Konkan",
      "description": "Family Tempo Traveller Konkan ensures a safe and comfortable journey for families visiting Konkan. Vehicles offer ample seating, luggage space, and child-friendly features for long-distance travel. Experienced drivers follow safe routes, ensuring a stress-free journey. Ideal for weekend trips, vacations, or sightseeing tours, this service prioritizes family convenience, safety, and comfort."
    },
    {
      "name": "Group Travel Konkan Tempo Traveller",
      "description": "Group Travel Konkan Tempo Traveller caters to large groups visiting the Konkan region. Vehicles are spacious, well-maintained, and equipped for long-distance travel, providing comfort for all passengers. Professional drivers manage the journey efficiently, ensuring timely arrivals and a smooth experience. Perfect for corporate groups, school trips, or friends traveling together, this service guarantees reliable and enjoyable travel."
    },
    {
      "name": "Affordable Tempo Traveller Konkan Tour",
      "description": "Affordable Tempo Traveller Konkan Tour offers budget-friendly rental options for groups traveling along the Konkan coast. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, ensuring a safe and comfortable journey. Ideal for family outings, friends’ trips, or corporate tours seeking economical transport, this service combines affordability with reliability and convenience."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Konkan",
      "description": "Chauffeur Driven Tempo Traveller Konkan provides professional drivers for hassle-free travel to Konkan destinations. Passengers can relax while skilled chauffeurs manage the routes and traffic. Spacious and comfortable vehicles accommodate families, friends, or corporate groups, ensuring convenience, safety, and peace of mind throughout the journey."
    },
    {
      "name": "Tempo Traveller for Konkan Package",
      "description": "Tempo Traveller for Konkan Package offers vehicles for customized tour packages along the Konkan coast. Ideal for sightseeing, corporate retreats, or family vacations, these vehicles provide ample space, comfort, and luggage capacity. Professional drivers ensure timely pick-ups and smooth transfers, making package tours convenient, enjoyable, and stress-free."
    },
    {
      "name": "Best Tempo Traveller Konkan Darshan",
      "description": "Best Tempo Traveller Konkan Darshan provides top-quality vehicles and professional service for a superior travel experience along the Konkan coast. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth journey. Suitable for families, friends, and corporate travelers, this service emphasizes safety, punctuality, and comfort."
    },
    {
      "name": "Pune Konkan Tour Vehicle",
      "description": "Pune Konkan Tour Vehicle provides dependable and comfortable transport for individuals or groups traveling from Pune to Konkan destinations. Vehicles are spacious, maintained for safety, and equipped for long-distance travel. Experienced drivers manage scenic coastal routes efficiently, ensuring a smooth and enjoyable journey for sightseeing, leisure trips, or corporate tours."
    },
    {
      "name": "Corporate Konkan Tour Tempo Traveller",
      "description": "Corporate Konkan Tour Tempo Traveller caters to business travelers and office groups visiting Konkan destinations. Vehicles provide premium interiors, spacious seating, and amenities for relaxation or work during travel. Professional chauffeurs ensure punctuality and safe driving, making it ideal for corporate retreats, meetings, or incentive tours."
    },
    {
      "name": "Tempo Traveller Long Tour Konkan",
      "description": "Tempo Traveller Long Tour Konkan offers vehicles for extended trips along the Konkan coast. Perfect for multi-day journeys, family vacations, or group tours, these vehicles provide comfort, spacious seating, and luggage-friendly interiors. Experienced drivers ensure safe and efficient travel, making long tours convenient, relaxing, and enjoyable."
    },
    {
      "name": "Konkan Tourism Tempo Traveller",
      "description": "Konkan Tourism Tempo Traveller provides specialized vehicles for sightseeing and tourism across Konkan. Ideal for families, friends, or corporate groups, these vehicles offer comfort, ample space, and professional drivers. Enjoy scenic coastal routes, historic landmarks, and cultural spots with a hassle-free and pleasant travel experience."
    },
    {
      "name": "Pune to Ratnagiri Tempo Traveller",
      "description": "Pune to Ratnagiri Tempo Traveller offers reliable and comfortable vehicles for travel between Pune and Ratnagiri. Perfect for long-distance family trips, group tours, or corporate outings, these vehicles provide spacious seating, luggage space, and air-conditioning. Professional drivers ensure safe driving and timely arrivals, making the journey smooth, convenient, and enjoyable."
    }
  ],
  "tableData": [
    ["Pune to Konkan Darshan Tempo Traveller Hire", "Konkan Darshan Tempo Traveller from Pune"],
    ["AC Tempo Traveller Konkan Tour", "Luxury Tempo Traveller Konkan Darshan"],
    ["Family Tempo Traveller Konkan", "Group Travel Konkan Tempo Traveller"],
    ["Affordable Tempo Traveller Konkan Tour", "Chauffeur Driven Tempo Traveller Konkan"],
    ["Tempo Traveller for Konkan Package", "Best Tempo Traveller Konkan Darshan"],
    ["Pune Konkan Tour Vehicle", "Corporate Konkan Tour Tempo Traveller"],
    ["Tempo Traveller Long Tour Konkan", "Konkan Tourism Tempo Traveller"],
    ["Pune to Ratnagiri Tempo Traveller", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Konkan Darshan Tempo Traveller Hire with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Pune to Konkan Darshan Tempo Traveller hire services, ideal for family trips, group tours, pilgrimage journeys, and scenic coastal travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Enjoy a relaxed Konkan Darshan journey from Pune in spacious, air-conditioned, and well-maintained Tempo Travellers designed for group travel."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Konkan Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with Konkan coastal and ghat routes, ensuring safe and smooth travel throughout the tour."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Konkan Darshan Tempo Traveller hire, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from customized Tempo Traveller hire plans tailored for multi-day Pune to Konkan Darshan tours."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before and during the journey to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure dependable service and well-planned schedules, making Sanavi Travels a trusted choice for Pune to Konkan Darshan Tempo Traveller hire."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Konkan Darshan Tempo Traveller hire?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune to Konkan Darshan tours.'
  },
  {
    question: 'How can I book a Pune to Konkan Darshan Tempo Traveller with Sanavi Travels?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Is the Tempo Traveller suitable for multi-day Konkan Darshan tours?',
    answer: 'Yes, our Tempo Travellers are ideal for multi-day and long-distance Konkan Darshan journeys.'
  },
  {
    question: 'Are drivers experienced with Konkan Darshan routes?',
    answer: 'Yes, our drivers are highly experienced with Konkan coastal roads and sightseeing routes.'
  },
  {
    question: 'Is the Pune to Konkan Darshan Tempo Traveller service available 24x7?',
    answer: 'Yes, our Tempo Traveller hire service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the tour?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Konkan Darshan itinerary?',
    answer: 'Absolutely. Sanavi Travels offers customized Konkan Darshan tour plans as per your requirements.'
  },
  {
    question: 'What payment options are available for Pune to Konkan Darshan Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the Konkan Darshan tour?',
    answer: 'Yes, our 24x7 customer support team is available throughout the tour.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Sawant',
    feedback: 'Our Pune to Konkan Darshan trip with Sanavi Travels was wonderful. Comfortable Tempo Traveller and very knowledgeable driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Snehal Patil',
    feedback: 'Excellent service! Clean vehicle, well-planned tour, and smooth travel throughout Konkan Darshan.',
    rating: 5
  }
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Tempo Traveller Hire - Sanavi Travels",
  "description": "Pune to Konkan Darshan tempo traveller hire by Sanavi Travels for Konkan tourism, family tours, long-distance trips, corporate outings, and group travel. Choose AC and luxury tempo travellers for a comfortable and affordable Konkan Darshan journey including Ratnagiri routes.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3564"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Konkan Darshan Tempo Traveller Hire Starting from ₹33 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Konkan Darshan tempo traveller hire with Sanavi Travels. AC and luxury tempo traveller for Konkan tour packages, Ratnagiri travel, family, corporate and group trips at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkandarshantempo;